// export const symbols = {
//   sensexCoCode: 20558,
//   sensexEdelCode: "SENSEX",
//   niftyCoCode: 20559,
//   niftyEdelCode: "NIFTY",
//   nifty500CoCode: 22115,
//   BSESymbol: "-101",
//   NSESymbol: "-29",
//   contactNo: "1800-102-3335",
// };
export const symbols = [
    {
        CoCode: 20558,
        EdelCode: "Sensex",
        symbol: "-101",
        code: "BSE",
    },
    {
        CoCode: 20559,
        EdelCode: "Nifty 50",
        "500CoCode": 22115,
        symbol: "-29",
        code: "NSE",
    },
    {
        CoCode: 22113,
        EdelCode: "Nifty Next 50",
        symbol: "-23",
        code: "NSE",
    },
    {
        CoCode: 27176,
        EdelCode: "Nifty 100",
        symbol: "-25",
        code: "NSE",
    },
    {
        CoCode: 41356,
        EdelCode: "Nifty 200",
        symbol: "-43",
        code: "NSC",
    },
    {
        CoCode: 22115,
        EdelCode: "Nifty 500",
        symbol: "-44",
        code: "NSC",
    },
    {
        CoCode: 26771,
        EdelCode: "NIFTY MIDCAP 100",
        symbol: "-22",
        code: "NSC",
    },
    {
        CoCode: 40939,
        EdelCode: "NIFTY SMLCAP 100",
        symbol: "-45",
        code: "NSC",
    },
    {
        CoCode: 26753,
        EdelCode: "Nifty Bank",
        symbol: "-21",
        code: "NSC",
    },
];
